// extracted by mini-css-extract-plugin
export default {"container":"WaitingServerConnection_container__6THiE","appear":"WaitingServerConnection_appear__Hf9r9","main_image":"WaitingServerConnection_main_image__FQXzK"};